export default "__VITE_ASSET__wfZqCtim__"